import { get, FieldErrors } from "react-hook-form";

/** True when errorPath has a direct RHF error with a message (not merely a nested child error). */
export function hasLeafReviewError(errors: FieldErrors, errorPath: string): boolean {
  const fieldError = get(errors, errorPath);
  return Boolean(fieldError && typeof fieldError === "object" && "message" in fieldError && fieldError.message);
}
